export const FlagUA = () => (
  <svg
    height="15px"
    version="1.1"
    viewBox="0 0 21 15"
    width="21px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="linearGradient-ua-1"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFFFFF"></stop>
        <stop offset="100%" stopColor="#F0F0F0"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient-ua-2"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#156DD1"></stop>
        <stop offset="100%" stopColor="#0D5EB9"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient-ua-3"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFD948"></stop>
        <stop offset="100%" stopColor="#FFD430"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      id="Symbols"
      stroke="none"
      strokeWidth="1"
    >
      <g id="UA">
        <rect
          fill="url(#linearGradient-ua-1)"
          height="15"
          id="FlagBackground"
          width="21"
          x="0"
          y="0"
        ></rect>
        <rect
          fill="url(#linearGradient-ua-2)"
          height="8"
          id="Rectangle-2"
          width="21"
          x="0"
          y="0"
        ></rect>
        <rect
          fill="url(#linearGradient-ua-3)"
          height="7"
          id="Rectangle-2"
          width="21"
          x="0"
          y="8"
        ></rect>
      </g>
    </g>
  </svg>
);

export const FlagUS = () => (
  <svg
    height="15px"
    version="1.1"
    viewBox="0 0 21 15"
    width="21px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>US</title>
    <defs>
      <linearGradient
        id="linearGradient-us-1"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFFFFF"></stop>
        <stop offset="100%" stopColor="#F0F0F0"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient-us-2"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#D02F44"></stop>
        <stop offset="100%" stopColor="#B12537"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient-us-3"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#46467F"></stop>
        <stop offset="100%" stopColor="#3C3C6D"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      id="Symbols"
      stroke="none"
      strokeWidth="1"
    >
      <g id="US">
        <rect
          fill="url(#linearGradient-us-1)"
          height="15"
          id="FlagBackground"
          width="21"
          x="0"
          y="0"
        ></rect>
        <path
          d="M0,0 L21,0 L21,1 L0,1 L0,0 Z M0,2 L21,2 L21,3 L0,3 L0,2 Z M0,4 L21,4 L21,5 L0,5 L0,4 Z M0,6 L21,6 L21,7 L0,7 L0,6 Z M0,8 L21,8 L21,9 L0,9 L0,8 Z M0,10 L21,10 L21,11 L0,11 L0,10 Z M0,12 L21,12 L21,13 L0,13 L0,12 Z M0,14 L21,14 L21,15 L0,15 L0,14 Z"
          fill="url(#linearGradient-us-2)"
          id="Rectangle-511"
        ></path>
        <rect
          fill="url(#linearGradient-us-3)"
          height="7"
          id="Rectangle-511"
          width="9"
          x="0"
          y="0"
        ></rect>
        <path
          d="M1.5,2 C1.22385763,2 1,1.77614237 1,1.5 C1,1.22385763 1.22385763,1 1.5,1 C1.77614237,1 2,1.22385763 2,1.5 C2,1.77614237 1.77614237,2 1.5,2 Z M3.5,2 C3.22385763,2 3,1.77614237 3,1.5 C3,1.22385763 3.22385763,1 3.5,1 C3.77614237,1 4,1.22385763 4,1.5 C4,1.77614237 3.77614237,2 3.5,2 Z M5.5,2 C5.22385763,2 5,1.77614237 5,1.5 C5,1.22385763 5.22385763,1 5.5,1 C5.77614237,1 6,1.22385763 6,1.5 C6,1.77614237 5.77614237,2 5.5,2 Z M7.5,2 C7.22385763,2 7,1.77614237 7,1.5 C7,1.22385763 7.22385763,1 7.5,1 C7.77614237,1 8,1.22385763 8,1.5 C8,1.77614237 7.77614237,2 7.5,2 Z M2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.22385763 2.22385763,2 2.5,2 C2.77614237,2 3,2.22385763 3,2.5 C3,2.77614237 2.77614237,3 2.5,3 Z M4.5,3 C4.22385763,3 4,2.77614237 4,2.5 C4,2.22385763 4.22385763,2 4.5,2 C4.77614237,2 5,2.22385763 5,2.5 C5,2.77614237 4.77614237,3 4.5,3 Z M6.5,3 C6.22385763,3 6,2.77614237 6,2.5 C6,2.22385763 6.22385763,2 6.5,2 C6.77614237,2 7,2.22385763 7,2.5 C7,2.77614237 6.77614237,3 6.5,3 Z M7.5,4 C7.22385763,4 7,3.77614237 7,3.5 C7,3.22385763 7.22385763,3 7.5,3 C7.77614237,3 8,3.22385763 8,3.5 C8,3.77614237 7.77614237,4 7.5,4 Z M5.5,4 C5.22385763,4 5,3.77614237 5,3.5 C5,3.22385763 5.22385763,3 5.5,3 C5.77614237,3 6,3.22385763 6,3.5 C6,3.77614237 5.77614237,4 5.5,4 Z M3.5,4 C3.22385763,4 3,3.77614237 3,3.5 C3,3.22385763 3.22385763,3 3.5,3 C3.77614237,3 4,3.22385763 4,3.5 C4,3.77614237 3.77614237,4 3.5,4 Z M1.5,4 C1.22385763,4 1,3.77614237 1,3.5 C1,3.22385763 1.22385763,3 1.5,3 C1.77614237,3 2,3.22385763 2,3.5 C2,3.77614237 1.77614237,4 1.5,4 Z M2.5,5 C2.22385763,5 2,4.77614237 2,4.5 C2,4.22385763 2.22385763,4 2.5,4 C2.77614237,4 3,4.22385763 3,4.5 C3,4.77614237 2.77614237,5 2.5,5 Z M4.5,5 C4.22385763,5 4,4.77614237 4,4.5 C4,4.22385763 4.22385763,4 4.5,4 C4.77614237,4 5,4.22385763 5,4.5 C5,4.77614237 4.77614237,5 4.5,5 Z M6.5,5 C6.22385763,5 6,4.77614237 6,4.5 C6,4.22385763 6.22385763,4 6.5,4 C6.77614237,4 7,4.22385763 7,4.5 C7,4.77614237 6.77614237,5 6.5,5 Z M7.5,6 C7.22385763,6 7,5.77614237 7,5.5 C7,5.22385763 7.22385763,5 7.5,5 C7.77614237,5 8,5.22385763 8,5.5 C8,5.77614237 7.77614237,6 7.5,6 Z M5.5,6 C5.22385763,6 5,5.77614237 5,5.5 C5,5.22385763 5.22385763,5 5.5,5 C5.77614237,5 6,5.22385763 6,5.5 C6,5.77614237 5.77614237,6 5.5,6 Z M3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 C3.77614237,5 4,5.22385763 4,5.5 C4,5.77614237 3.77614237,6 3.5,6 Z M1.5,6 C1.22385763,6 1,5.77614237 1,5.5 C1,5.22385763 1.22385763,5 1.5,5 C1.77614237,5 2,5.22385763 2,5.5 C2,5.77614237 1.77614237,6 1.5,6 Z"
          fill="url(#linearGradient-us-1)"
          id="Oval-43"
        ></path>
      </g>
    </g>
  </svg>
);

export const FlagRu = () => (
  <svg
    height="15px"
    version="1.1"
    viewBox="0 0 21 15"
    width="21px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>RU</title>
    <defs>
      <linearGradient
        id="linearGradient-ru-1"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#F0F0F0" />
      </linearGradient>
      <linearGradient
        id="linearGradient-ru-2"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#0C47B7" />
        <stop offset="100%" stopColor="#073DA4" />
      </linearGradient>
      <linearGradient
        id="linearGradient-ru-3"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#E53B35" />
        <stop offset="100%" stopColor="#D32E28" />
      </linearGradient>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      id="Symbols"
      stroke="none"
      strokeWidth="1"
    >
      <g id="RU">
        <rect
          fill="url(#linearGradient-ru-1)"
          height="15"
          id="FlagBackground"
          width="21"
          x="0"
          y="0"
        />
        <rect
          fill="url(#linearGradient-ru-2)"
          height="5"
          id="Rectangle-2"
          width="21"
          x="0"
          y="5"
        />
        <rect
          fill="url(#linearGradient-ru-3)"
          height="5"
          id="Rectangle-2"
          width="21"
          x="0"
          y="10"
        />
        <rect
          fill="url(#linearGradient-ru-1)"
          height="5"
          id="Rectangle-2"
          width="21"
          x="0"
          y="0"
        />
      </g>
    </g>
  </svg>
);
